var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "main-spinner-panel" }, [
        !_vm.slider ? _c("div", { staticClass: "spacer" }) : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "spinner-border text-primary mt-2",
          attrs: { role: "status" }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.slider,
                expression: "slider"
              }
            ],
            staticClass: "spinner-images"
          },
          [
            _c("vcarousel", {
              staticClass: "lg",
              attrs: {
                data: _vm.list,
                controls: false,
                indicators: false,
                autoplay: true,
                interval: 4000,
                pauseOnEnter: false
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46b3b78e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b3b78e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/common/MainSpinnerPanel.vue
// module id = null
// module chunks = 